import { useMutation, useQueryClient } from '@tanstack/react-query';

import { withGlobalError } from '@/react-tools/react-query';
import axios, { parseAxiosError } from '@/portainer/services/axios';

import { PolicyId, TypedPolicy } from '../types';

import { queryKeys } from './query-keys';
import { UpdatePolicyPayload } from './types';

export function useUpdatePolicyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: PolicyId;
      payload: UpdatePolicyPayload;
    }) => updatePolicy(id, payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.list() });
      queryClient.setQueryData(queryKeys.detail(data.Id), data);
    },
    ...withGlobalError('Unable to update policy'),
  });
}

async function updatePolicy(
  id: PolicyId,
  payload: UpdatePolicyPayload
): Promise<TypedPolicy<unknown>> {
  try {
    const { data } = await axios.put<TypedPolicy<unknown>>(
      `/policies/${id}`,
      payload
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to update policy');
  }
}
